import { createContext, type PropsWithChildren, useContext } from 'react';

import { useGlobal } from '~/hooks/useGlobal';
import { useStoreInstance } from '~/hooks/useStoreInstance';
import { HomeCategories, ShopCategories } from '~/stores/CategoriesStore';
import { HeroBannerStore } from '~/stores/HeroBannerStore';

export interface Stores {
  shopCategories: ShopCategories;
  homeCategories: HomeCategories;
  heroBanner: HeroBannerStore;
}

export const StoresContext = createContext<Nullable<Stores>>(null);

export const useStores = (): Stores => {
  const stores = useContext(StoresContext);

  if (!stores) {
    throw new Error('Use stores before initialization');
  }

  return stores;
};

export const StoresProvider = ({ children }: PropsWithChildren) => {
  const { serverWarehouse, serverLang } = useGlobal();

  const shopCategories = useStoreInstance(
    ShopCategories,
    serverWarehouse,
    serverLang,
  );

  const homeCategories = useStoreInstance(
    HomeCategories,
    shopCategories,
    serverWarehouse,
    serverLang,
  );

  const heroBanner = useStoreInstance(
    HeroBannerStore,
    serverWarehouse,
    serverLang,
  );

  return (
    <StoresContext.Provider
      value={{ shopCategories, homeCategories, heroBanner }}
    >
      {children}
    </StoresContext.Provider>
  );
};
